import React from "react";
import {
  Typography,
  Stack,
  Box,
  Divider,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import footerBannerImg from "../../src/assets/brightspeed-pattern-full-color-rgb-brightspeed-logo-full-color-rgb.png";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getLoginFooterPageContent } from "../SharedContextStore/slices/newLoginFooterContent";
import { toggleOneTrust } from "../Utils/utils";
import { LoginFooterContent } from "../SharedComponents/contents";



const FooterLayout = () => {
  const [anchorActive, setAnchorActive] = useState(" ");
  const dispatch = useAppDispatch();
  const loginFooterContent : any = LoginFooterContent();
  const FOOTER_CONTENT_CDN = loginFooterContent?.entry;
  const FOOTER_CONTENT_Recaptcha = loginFooterContent?.entry?.recaptcha;
  
  const topLinksActive = (e: any, label: any = "") => {
    setAnchorActive(label);
  };
  useEffect(() => {
    getContent();
  }, []);

  const getContent = async () => {
    await dispatch(getLoginFooterPageContent());
  };

  const handleUrlCall = (value: string) => {
    window.open(value, "");
  };
  const platformMapping = {
    facebook: "facebook",
    instagram: "instagram",
    linkedin: "linkedin",
    twitter: "twitter",
  };
  return (
    <Stack>
      {loginFooterContent?.entry && (
        <footer  role="contentinfo">
        <Stack className="fullFooter">
          <Box className="footerContainer">
            <Box className="topRow">
              <Box className="main">
                <Box className="socialIcons">
                  <Typography component="h4" className="followus">
                    {FOOTER_CONTENT_CDN?.row1?.follow_us_label}
                  </Typography>
                  {FOOTER_CONTENT_CDN?.row1?.follow_us_links?.map(
                    (item: any, i: any) => {
                      const platformName = Object.keys(platformMapping).find((key) => item.href.includes(key))
                      return (
                        <a key={item.href} href={item.href} target="_blank"  aria-label={platformName} >
                          <img
                            className="socialMedia"
                            src={item.logo?.url}
                            alt={platformName}
                          />
                        </a>
                      );
                    }
                  )}
                </Box>
                <Box className="brspdLogo">
                  <a aria-label="Brightspeed logo" href={FOOTER_CONTENT_CDN?.row1?.logo_href}>
                    <img
                      className="footerLogo"
                      src={FOOTER_CONTENT_CDN?.row1?.logo?.url}
                      alt="Brightspeed logo"
                    />
                  </a>
                </Box>
              </Box>
            </Box>
            <Box className="midRow">
              <Box className="main">
                <Box className="column1">
                  <Box className="main">
                    <Box className="list">
                      <Typography component="span" className="title">
                        {FOOTER_CONTENT_CDN?.row2?.column1?.title}
                      </Typography>
                      {FOOTER_CONTENT_CDN?.row2?.column1?.links?.map(
                        (item: any, i: any) => {
                          const index = i + 1;
                          return (
                            <a key={item.label+index}
                              href={item.href}
                              onClick={(event: any) =>
                                topLinksActive(event, index)
                              }
                              className={
                                anchorActive == index && anchorActive != " "
                                  ? "footerLinkActive"
                                  : ""
                              }
                            >
                              {item.label}
                            </a>
                          );
                        }
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box className="column2">
                  <Box className="main">
                    <Typography component="h3" className="title">
                      For customers
                    </Typography>
                    <Box className="list">
                      <Typography component="span" className="title">
                        {FOOTER_CONTENT_CDN?.row2?.column2?.title}
                      </Typography>
                      {FOOTER_CONTENT_CDN?.row2?.column2?.links?.map(
                        (item: any, i: any) => {
                          const index = i + 5;
                          return (
                            <a key={item.label+index}
                              href={item.href}
                              onClick={(event: any) =>
                                topLinksActive(event, index)
                              }
                              className={
                                anchorActive == index && anchorActive != " "
                                  ? "footerLinkActive"
                                  : ""
                              }
                            >
                              {item.label}
                            </a>
                          );
                        }
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box className="column3">
                  <Box className="main">
                    <Typography component="h3" className="title">
                    {FOOTER_CONTENT_CDN?.row2?.column3?.title}
                    </Typography>
                    <Box className="list">
                      <Typography component="span" className="title">
                        {FOOTER_CONTENT_CDN?.row2?.column3?.title}
                      </Typography>
                      {FOOTER_CONTENT_CDN?.row2?.column3?.links?.map(
                        (item: any, i: any) => {
                          const index = i + 12;
                          return (
                            <a key={item.label+index}
                              href={item.href}
                              onClick={(event: any) =>
                                topLinksActive(event, index)
                              }
                              className={
                                anchorActive == index && anchorActive != " "
                                  ? "footerLinkActive"
                                  : ""
                              }
                            >
                              {item.label}
                            </a>
                          );
                        }
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box className="bottomRow">
              <Box>
              <Box className="leftRow">
                <Typography component="span" className="copyText">
                  {FOOTER_CONTENT_CDN?.row3?.copyright}
                </Typography>
                <Divider
                  className="large-deviceHr"
                  orientation="vertical"
                  flexItem
                  sx={{ display: "none" }}
                />
                <Box className="links">
                  {FOOTER_CONTENT_CDN?.row3?.links?.map((item: any, i: any) => {
                    const index = i + 20;
                    return (
                      <React.Fragment key={item.label+index}>
                        {item.label == "Cookie preferences" ? (
                          <React.Fragment key={item.label}>
                            <a
                              href="#"
                              onClick={(e) => {
                                toggleOneTrust();
                                e.preventDefault();
                              }}
                            >
                              {item.label}
                            </a>
                            <Divider orientation="vertical" flexItem role="presentation" />
                          </React.Fragment>
                        ) : (
                          <React.Fragment key={item.label}>
                            <a
                              href={item.href}
                              onClick={(event: any) =>
                                topLinksActive(event, index)
                              }
                              className={
                                anchorActive == index && anchorActive != " "
                                  ? "footerLinkActive"
                                  : ""
                              }
                            >
                              {item.label}
                            </a>
                            <Divider orientation="vertical" flexItem role="presentation"/>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    );
                  })}
                </Box>
                  </Box>
                  <Box>
                    <Typography className="recaptcha-text">
                    {FOOTER_CONTENT_Recaptcha?.prefix} <a target="_blank" href={FOOTER_CONTENT_Recaptcha?.privacyPolicy?.url}>{FOOTER_CONTENT_Recaptcha?.privacyPolicy?.text}</a> {FOOTER_CONTENT_Recaptcha?.and} <a target="_blank" href={FOOTER_CONTENT_Recaptcha?.termsOfService?.url}>{FOOTER_CONTENT_Recaptcha?.termsOfService?.text}</a> {FOOTER_CONTENT_Recaptcha?.suffix}
                    </Typography>
                </Box>
              </Box>
              <Box className="rightRow">
                <Box className="brspdLogo">
                  <a aria-label="Brightspeed logo" href={FOOTER_CONTENT_CDN?.row1?.logo_href}>
                    <img
                      className="footerLogo"
                      src={FOOTER_CONTENT_CDN?.row1?.logo.url}
                      alt="Brightspeed logo"
                    />
                  </a>
                </Box>
              </Box>
            </Box>
          </Box>
        </Stack>
        </footer>
      )}
    </Stack>
  );
};
export default FooterLayout;
